module.exports = __webpack_public_path__ + "media/images/inventory-hover-cbd09ce107c186721851d5bfa2bbd3c7.svg";